const destinations = [
  { name: "Germany", context: "Sheppard AFB PCS to Ramstein, Stuttgart, Spangdahlem; also NATO pilot training connections", urgency: "PCS orders often arrive with 14–30 days to report", icon: "ri-map-pin-2-line" },
  { name: "United Kingdom", context: "RAF Lakenheath / Mildenhall military assignments, NATO-related travel, business travel to London", urgency: "Military orders have immovable report dates — dependent passports must be current", icon: "ri-map-pin-2-line" },
  { name: "Caribbean & Mexico", context: "Family vacation getaways via DFW, cruise departures from Galveston, spring break travel", urgency: "Families book 3–6 weeks out and often discover expired passports last minute", icon: "ri-map-pin-2-line" },
  { name: "Japan & South Korea", context: "Pacific Command deployments, Yokosuka / Okinawa PCS, USFK rotations from DFW", urgency: "Deployment orders have immovable departure windows", icon: "ri-map-pin-2-line" },
  { name: "Canada", context: "Business travel, family road trips, summer lake vacations, Niagara Falls tourism", urgency: "Summer travel peaks May through August with short booking timelines", icon: "ri-map-pin-2-line" },
  { name: "Europe (Leisure)", context: "Retirement travel to France, Italy, Spain; MSU study-abroad programs; heritage travel", urgency: "Retirees and students often plan 4–8 weeks out — cutting it close for standard processing", icon: "ri-map-pin-2-line" },
];

const stats = [
  { stat: "70%", label: "of Wichita Falls expedited requests are military-related or within 3 weeks of travel" },
  { stat: "2–4 Weeks", label: "average notice Wichita Falls travelers have before planned international departure" },
  { stat: "May–Aug", label: "peak season when PCS cycles and family vacation bookings collide" },
  { stat: "120 Mi", label: "to DFW — making document shipping an easier choice than driving for passport services" },
];

export default function WichitaFallsDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Wichita Falls Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from North Texas clients. Understanding local travel behavior is part of why our document review catches issues before they derail your PCS, vacation, or business trip.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Texas Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">We serve travelers across Texas with the same expedited passport processing expertise. Looking for service in another community?</p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              {[{ name: "Dallas", href: "/cities/dallas" }, { name: "Fort Worth", href: "/cities/fort-worth" }, { name: "Lubbock", href: "/cities/lubbock" }].map((l) => (
                <a key={l.href} href={l.href} className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                  {l.name} <i className="ri-arrow-right-line text-xs"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}